import store from '../store/state';

window.franchisee = {};
(function () {
    let _franchisee = {};
    _franchisee.pms = [
        "institution-index-all",   // 查看所有加盟商信息权限
        "institution-index-sub",   // 查看自己及下属负责的所有加盟商权限（对应加盟商负责人字段）
        "institution-index-subSource",  // 查看自己及下属负责的所有加盟商权限（对应“来源负责人”字段）
        "institution-add",        // 新增加盟商权限
        "institution-edit-all",   // 编辑所有加盟商信息详情权限（指所有可编辑字段，其中“合作有效期”的修改权限，如该员工拥有“编辑加盟商合作有效期的权限，则可以编辑”合作有效期“字段信息；“联系方式”编辑权限，如该员工拥有”查看加盟商联系方式权限“的权限，则可以编辑“联系方式”字段信息。）
        "institution-edit-sub",   // 编辑自己以及下属负责的所有加盟商信息详情权限（指所有可编辑字段，其中“合作有效期”的修改权限，如该员工拥有“编辑加盟商合作有效期的权限，则可以编辑”合作有效期“字段信息；“联系方式”编辑权限，如该员工拥有”查看加盟商联系方式权限“的权限，则可以编辑“联系方式”字段信息。）
        "institution-editCourse-all",  // 编辑所有加盟商课程使用权限
        "institution-editCourse-sub",  // 编辑自己以及下属负责的所有加盟商课程使用权限
        "institution-effective-all",  // 编辑所有加盟商合作权限有效期权限（包含加盟商信息管理列表的“合作生效”功能、“修改合作有效期”功能；加盟商信息详情的“合作有效期”功能）
        "institution-effective-sub",  // 编辑自己以及下属负责的所有加盟商合作权限有效期权限（包含加盟商信息管理列表的“合作生效”功能、“修改合作有效期”功能；加盟商信息详情的“合作有效期”功能）
        "institution-stealthLogin",  // 使用隐身登录的权限（建立在“加盟商信息管理查看权限”上，没有查看权限，就没有相关加盟商编辑权限）
        "institution-cooperationStatus",  // 暂停/恢复加盟商合作有效期的权限（建立在“加盟商信息管理查看权限”上，没有查看权限，就没有相关加盟商编辑权限）
        "institution-editAccount",  // 编辑加盟商管理员账号权限
        "institution-adminUser-all",  // 查看所有员工列表权限
        "institution-adminUser-sub",  // 查看自己及下属负责的所有员工信息权限
        "institution-editAdminUser-all",  // 拥有新建/编辑所有员工信息权限（包括基础信息、角色的修改权限）
        "institution-editAdminUser-sub",  // 拥有新建/编辑自己及下属负责的所有员工信息权限（包括基础信息、角色的修改权限）
        "institution-editDepartment",  // 编辑部门信息权限（包括新增、编辑、删除）
        "institution-editPosition",  // 编辑岗位信息权限（包括新增、编辑、删除）
        "institution-permission",  // 查看权限列表权限
        "institution-role",   // 查看角色列表
        "institution-editRole",   // 设置角色权限功能（包括新建角色、编辑角色名称、编辑角色权限内容、删除角色权限）
        "institution-detail-all",   // 查看所有加盟商信息详情权限（包括信息详情、合作资料、课程使用权限、管理员账号、加盟商日志，不包括“联系方式”的查看权限）
        "institution-detail-sub",   // '查看自己及下属负责的所有加盟商信息详情权限（包括信息详情、合作资料、课程使用权限、管理员账号、加盟商日志，不包括“联系方式”的查看权限）
        "institution-viewPhone-all",  // 查看所有加盟商联系方式权限（拥有此查看权限，才能编辑加盟商联系方式）
        "institution-viewPhone-sub",  // 查看自己及下属负责的所有加盟商联系方式权限（拥有此查看权限，才能编辑加盟商联系方式）
        "institution-index-export",   // 导出加盟商列表信息权限
        "institution-batchUpdate-operater",  // 批量修改加盟商负责人
        "institution-ipindex-all",    // 查看所有客户填表单IP地址权限
        "institution-ipindex-sub",    // 查看自己及下属负责的客户填表单IP地址权限
        "institution-ipindex-export",   // 导出客户填表单IP地址数据
        "institution-adminLogin-all",  // 查看所有员工登录信息列表权限
        "institution-adminLogin-sub",  //  查看自己及下属员工登录信息列表权限
        "institution-bcLogin-all",    //查看所有机构、学生端登录信息权限
        "institution-uploadCoop-all",  // 上传所有加盟商合作资料权限
        "institution-uploadCoop-sub",  // 上传自己以及下属负责的所有加盟商合作资料权限
        "institution-poolIndex-all",  // 查看所有客户
        "institution-poolSource-sub",  // 查看自己以及下属负责的客户（对应“来源负责人”字段）
        "institution-poolOwner-sub",  // 查看自己以及下属负责的客户（对应“客户负责人”字段）
        "institution-poolPhone-all",  // 客户池加盟商联系方式查看权限
        "institution-poolPhone-sub",  // 查看自己以及下属负责的客户（对应“客户负责人”字段）
        "institution-poolGet",  // 领取客户池客户的权限
        "institution-poolAssign-all",   // 客户池列表【批量分配客户】权限,分配给所有员工
        "institution-poolAssign-sub",  // 客户池列表【批量分配客户】权限,分配给自己及下属
        "institution-orderIndex-all",   // 订单列表（有效订单）查看权限
        "institution-orderIndex-sub",   // 订单列表（有效订单）查看权限,查看自己以及下属负责的客户订单数据（对应“客户负责人”字段）
        "institution-orderIndex-subSource", // 订单列表（有效订单）查看权限,查看自己以及下属负责的客户订单数据（对应“来源负责人”字段）
        "institution-orderCancelIndex-all",  // 订单列表（无效订单）查看权限
        "institution-orderCancelIndex-sub",  // 订单列表（无效订单）查看权限,查看自己以及下属负责的客户订单数据
        "institution-orderConfirm",  // 订单列表确认/取消确认订单的权限
        "institution-orderExport",   // 导出所有订单（基于查看权限）
        "institution-orderAdd-all",   // 为所有客户新建订单权限
        "institution-orderAdd-sub",   // 为自己及下属负责的客户新建订单权限
        "institution-orderCancel-all",   // 作废所有订单权限
        "institution-orderCancel-sub",  // 作废自己及下属是客户负责人的订单（对应当时客户负责人字段）
        "institution-sourceIndex-all",  // 来源列表查看权限
        "institution-sourceIndex-sub",  // 查看自己及下属负责的来源权限（对应来源负责人字段）
        "institution-addSource",  // 新建来源权限（允许新建1、2、3级来源）
        "institution-editSource",   // 编辑来源权限（允许编辑1、2、3级来源）
        "institution-putPool-all",  // 将客户放入客户池的权限
        "institution-putPool-sub",   // 放弃自己以及下属负责的客户
        "institution-import",    // 批量导入客户权限
        "instodo-view-all",   // 查看所有客户的待办事项
        "instodo-view-sub",   // 查看自己及下属负责的客户的待办事项
        "instodo-add-all",  // 添加所有客户的待办事项
        "instodo-add-sub",   // 添加自己及下属负责的客户待办事项
        "instodo-edit-all",  // 修改所有客户待办事项状态
        "instodo-edit-sub",   // 修改自己及下属负责的客户待办事项状态
        "inspooltodo-view-all",   // 查看所有客户池客户的待办事项
        "institution-utm-all",   // 查看所有客户营销来源
        "institution-utm-export",   // 导出所有客户营销来源
        "institution-orderEditReward",  // 延期优惠权限
        "institution-newSource-auth",   // 授权来源权限（允许授权4级来源）
        "institution-sourceIndex-subAndAuth",  // 查看自己及下属负责的来源以及被授权的来源的数据（对应来源负责人字段）
    ];

    _franchisee.hasPermission = function (pms) {
        if (!pms) {
            return false;
        }
        if (!_franchisee.pms) {
            return false;
        }
        let arr = JSON.parse(store.permission);
        if (arr.length > 0) {
            return arr.includes(pms);
        }
    };
    franchisee = _franchisee;
}).call(this);
export default franchisee;



// WEBPACK FOOTER //
// ./src/js/permissions.js